import styled from "styled-components"
import InnerContentText from "./InnerContextText"

const StyleInnerWrapper = styled.div`
  max-width: 800px;
  &:first-child {
    margin-top: 60px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-top: 20px;
    }
  }
`

type InnerContentProps = {
  nevergiveupData: { title: string; description: string[]; images?: string[] }
  imageSource?: string
}

const InnerContent = ({ nevergiveupData, imageSource }: InnerContentProps) => {
  return (
    <StyleInnerWrapper>
      <InnerContentText
        title={nevergiveupData.title}
        description={nevergiveupData.description}
        images={nevergiveupData.images}
        imageSource={imageSource}
      />
    </StyleInnerWrapper>
  )
}

export default InnerContent
